// Centralna konfiguracja paneli administracyjnych.
// Klucze odpowiadaja wartosciom gettera getActivePanel (store/modules/dod.js) i sessionStorage.

export const PANELS = {
  MAIN_APP: "MAIN_APP", // Panel Aplikacji (glowna aplikacja)
  DOD: "DOD", // Panel DOD FSAPP
  POD: "POD", // Panel POD (prywatna opieka)
};

export const PANEL_STORAGE_KEY = "seniorapp_active_panel";

export function getActivePanelFromStorage() {
  return window.sessionStorage.getItem(PANEL_STORAGE_KEY) || PANELS.MAIN_APP;
}

// Adres backendu (NestJS) per panel - axiosDod.js wybiera baseURL wg aktywnego panelu.
// DOD i POD to dwie instancje TEGO SAMEGO backendu na osobnych bazach (ten sam token SAtoken dziala na obu).
const isTest = false;
// UWAGA: baseURL dla DOD bierze sie z axiosDod.js (export URL) - to zrodlo prawdy dla DOD.
// Tutaj liczy sie tylko POD (interceptor w axiosDod.js nadpisuje baseURL wylacznie dla panelu POD).
export const PANEL_API_URL = {
  // DOD - tylko dla referencji (faktycznie uzywany URL z axiosDod.js): prod = dod.seniorapp.pl
  [PANELS.DOD]: isTest
    ? "http://localhost:3075/api"
    : "https://dod.seniorapp.pl/api",
  // POD: test = podtest.seniorapp.pl (38.242.128.38). PROD = pod.seniorapp.pl (75.119.144.1) - zmien przy przejsciu na prod.
  [PANELS.POD]: isTest
    ? "http://localhost:3041/api"
    : "https://pod.seniorapp.pl/api",
};

// Capabilities (flagi widocznosci) per panel.
// Konwencja: brak klucza lub true = element WIDOCZNY; false = element UKRYTY.
// FAIL-OPEN: literowka w nazwie capability NIE wywali UI (zwraca "widoczne").
// Dodanie kolejnego ukrycia = jedna linia ponizej (showXxx:false) + jedno v-if="panelCan('showXxx')" w komponencie.
export const PANEL_CAPABILITIES = {
  [PANELS.MAIN_APP]: {}, // glowna aplikacja - nic nie ukrywamy
  [PANELS.DOD]: {}, // pelny panel DOD
  [PANELS.POD]: {
    // Pelna mechanika DNR dla POD (usluga Spolki "Prywatna Opieka Domowa" w SAPP):
    // linkowanie opiekunow, sync zlecen, finish i rachunki dzialaja jak w DOD,
    // tylko na segmencie pod/* glownej aplikacji. Ukryte zostaja wylacznie raporty MOPS.
    showMopsReports: false, // raporty MOPS (W1/W2/W3/Suma godzin MOPS/Raport MOPS) - tylko DOD
  },
};

// Czysta funkcja - uzywana przez globalny mixin (szablony) oraz bezposrednio w computed (filtrowanie list).
export function panelCan(activePanel, capability) {
  const caps = PANEL_CAPABILITIES[activePanel];
  if (!caps) return true;
  return caps[capability] !== false;
}

// Etykieta przy opiekunach polaczonych z aplikacja SeniorApp (mainAppUserId ustawione):
// DOD oznacza ich "(SeniorApp)", POD ma wg zadania pokazywac "DNR".
export const PANEL_MAIN_APP_BADGE = {
  [PANELS.MAIN_APP]: "(SeniorApp)",
  [PANELS.DOD]: "(SeniorApp)",
  [PANELS.POD]: "DNR",
};

export function mainAppBadgeLabel(activePanel) {
  return PANEL_MAIN_APP_BADGE[activePanel] || "(SeniorApp)";
}

// Sciezki linkowania konta w glownej aplikacji roznia sie segmentem per panel:
// DOD -> dod/users/.../setDodUserId (usluga Fundacji), POD -> pod/users/.../setPodUserId (usluga Spolki).
export function mainAppSetUserIdPath(activePanel, phone) {
  return activePanel === PANELS.POD
    ? `/api/pod/users/phone/${phone}/setPodUserId`
    : `/api/dod/users/phone/${phone}/setDodUserId`;
}
